module.exports = __webpack_public_path__ + "img/02-04-img-06@2x.d9781abc.png";